import React from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";

import DetalleCard from "~business/Cards/DetalleCard";

import DescriptionIcon from "@mui/icons-material/Description";
import {
  setPolizaFileName,
  setTarjetaFileName,
  setCedulaMercosurFileName,
  setCuponeraFileName,
  setIsProcessingPoliza,
  setIsProcessingTarjeta,
  setIsProcessingCedulaMercosur,
  setIsProcessingCuponera,
} from "../actions";
import { useDispatch, useSelector } from "react-redux";
import ItemFileUploaderCard from "~business/Cards/ItemFileUploaderCard";

const useStyles = makeStyles(() => ({
  impresosDisabled: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.38,
    letterSpacing: "normal",
    textAlign: "left" as const,
    color: "#8B8B8B",
    paddingTop: "5%",
  },
}));

const title = "Documentación";

type Adjunto = "poliza" | "tarjeta" | "cedulaMercosur" | "cuponera";

/** El uploader entrega el nombre del archivo subido en `target.value`. */
type UploaderEvent = { target: { value: string } };

const adjuntos = {
  poliza: setPolizaFileName,
  tarjeta: setTarjetaFileName,
  cedulaMercosur: setCedulaMercosurFileName,
  cuponera: setCuponeraFileName,
};

interface ImpresosCardProps {
  isLoading: boolean;
  disabled?: boolean;
}

interface SliceImpresos {
  negocio?: string;
}

const useReduxSelector = () =>
  useSelector<any, SliceImpresos>((state) => {
    const detalle = state.detalleSolicitudEmisionReducer;
    return {
      negocio: detalle.detalleSolicitudEmision.negocio,
    };
  });

const ImpresosCard: React.FC<ImpresosCardProps> = ({ isLoading, disabled }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { negocio } = useReduxSelector();

  if (isLoading)
    return (
      <DetalleCard
        isLoading={isLoading}
        title={title}
        IconHeader={DescriptionIcon}
      />
    );

  const handleAdded = (event: unknown, adjunto: Adjunto) => {
    const action = adjuntos[adjunto];
    const value = `temp/${(event as UploaderEvent).target.value}`;
    dispatch(
      action({
        value: value,
        valid: true,
      })
    );
  };
  const handleRemoved = (event: unknown, adjunto: Adjunto) => {
    const action = adjuntos[adjunto];
    dispatch(
      action({
        value: null,
        valid: false,
      })
    );
  };

  const handleProcessingPoliza = (value: boolean) => {
    dispatch(setIsProcessingPoliza(value));
  };

  const handleProcessingTarjeta = (value: boolean) => {
    dispatch(setIsProcessingTarjeta(value));
  };

  const handleProcessingCedulaMercosur = (value: boolean) => {
    dispatch(setIsProcessingCedulaMercosur(value));
  };

  const handleProcessingCuponera = (value: boolean) => {
    dispatch(setIsProcessingCuponera(value));
  };

  return (
    <DetalleCard
      isLoading={isLoading}
      title={title}
      IconHeader={DescriptionIcon}
    >
      {disabled && (
        <Typography className={classes.impresosDisabled}>
          {"Se requiere ingresar Número de Póliza para cargar Documentación"}
        </Typography>
      )}
      {!disabled && (
        <>
          <ItemFileUploaderCard
            label={"Póliza (requerido)"}
            onAdded={(event) => handleAdded(event, "poliza")}
            onRemoved={(event) => handleRemoved(event, "poliza")}
            onProcessStart={handleProcessingPoliza}
            acceptImage={false}
            acceptPdf={true}
          />
          <ItemFileUploaderCard
            label={`Tarjeta ${negocio === "Prendarios" ? "(requerido)" : ""}`}
            onAdded={(event) => handleAdded(event, "tarjeta")}
            onRemoved={(event) => handleRemoved(event, "tarjeta")}
            onProcessStart={handleProcessingTarjeta}
            acceptImage={false}
            acceptPdf={true}
          />
          <ItemFileUploaderCard
            label={"Cédula Mercosur"}
            onAdded={(event) => handleAdded(event, "cedulaMercosur")}
            onRemoved={(event) => handleRemoved(event, "cedulaMercosur")}
            onProcessStart={handleProcessingCedulaMercosur}
            acceptImage={false}
            acceptPdf={true}
          />
          {negocio && negocio === "MercadoAbierto" && (
            <ItemFileUploaderCard
              label={"Cuponera"}
              onAdded={(event) => handleAdded(event, "cuponera")}
              onRemoved={(event) => handleRemoved(event, "cuponera")}
              onProcessStart={handleProcessingCuponera}
              acceptImage={false}
              acceptPdf={true}
            />
          )}
        </>
      )}
    </DetalleCard>
  );
};

export default ImpresosCard;
